// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fivkH","name":"styles_name__3ggr3","phone":"styles_phone__1MHCs"};